import { vec3, vec4 } from "gl-matrix";
import { wHitRecord } from "./wHitRecord.js";
import { MathConst } from "./wContants.js";

class wPlane {
    constructor(planeNormal, pointInPlane, width, depth) {
        
        this.normal_ = vec3.fromValues(0.0,1.0,0.0);

        if(planeNormal !== undefined)
        {
            vec3.normalize(this.normal_,planeNormal);
        }

        let dp = vec3.dot(pointInPlane, this.normal_);
        this.planeEq_ = vec4.fromValues(this.normal_[0],this.normal_[1],this.normal_[2],-dp);
        this.planeOrigo_ = vec3.create();
        vec3.scale(this.planeOrigo_, this.normal_, dp);
    }

    getNormal() {
        let N = vec3.create();
        vec3.copy(N, this.normal_);
        return N;
    }

    getOrigo() {
        let O = vec3.create();
        vec3.copy(O, this.planeOrigo_);
        return O;
    }

    getSignedDistance(p)
    {
        return vec3.dot(p, this.normal_) + this.planeEq_[3];
    }
   
    rayIntersect(ray) {
        var hitRecord = new wHitRecord();
        const N = this.normal_;
        let DN = vec3.dot(ray.getDirection(), N);

        if (Math.abs(DN) < MathConst.fEps2) return hitRecord; // too close to parallel, call it a miss

        let planeW = -vec3.dot(N, this.planeOrigo_);
        let dotON = vec3.dot(ray.getOrigin(), N);
        let t = (-planeW - dotON) / DN;

        if (t < 0.0) return hitRecord;

        let hitPos = ray.evaluateRay(t);
        let hitDir = vec3.create();

        vec3.sub(hitDir, hitPos, this.planeOrigo_);

        hitRecord.validHit_ = true;
        hitRecord.hitTimes_.push(t);

        return hitRecord;
    }

    getTriangulation() {
       /* let verts = this.getBoxCorners();
        let trianglution = [];

        for(let i = 0; i < wBoxTriIndices_.length; i+= 3)
        {
            trianglution.push(verts[wBoxTriIndices_[i]]);
            trianglution.push(verts[wBoxTriIndices_[i+1]]);
            trianglution.push(verts[wBoxTriIndices_[i+2]]);
        }

        return trianglution;*/
    }
}

export { wPlane };
